import React, { useState, useRef, useEffect } from "react";
import { Button, Container, Dropdown, Card } from "react-bootstrap";
import Header2 from "../component/Header2";
import MapList from '../assets/images/view-icon/map-list.svg'
import Map from '../assets/images/view-icon/map.svg'
import List from '../assets/images/view-icon/list.svg'
import Like from '../assets/images/like.svg'
import power from '../assets/images/power.svg'
import storey from '../assets/images/storey.svg'
import size from '../assets/images/scale.svg'
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { BASE_URL } from '../api/constants'
import CommercialHeader from "../component/CommercialHeader";
import useFavoritesList from "../hooks/useFavoritesList";
import FilterBar from "../component/FilterBar";
import usePropertySort from "../hooks/usePropertySort";

function Commercial() {
  const { isFavorite, toggleFavorite } = useFavoritesList();

  const [view, setView] = useState(window.innerWidth < 768 ? "list" : "both");
  const headerRef = useRef(null);
  const filterRef = useRef(null);
  const [resultHeight, setResultHeight] = useState("60vh");
  const [sort, setSort] = useState("Sort by");
const [county, setCounty] = useState("Nairobi");
  //Listings
  const [listings, setListings] = useState([]);

  const getListings = async () => {
    try {
      // Read current URL query parameters
      const params = new URLSearchParams(window.location.search);
      const property_type = params.get("property_type") || "commercial";
      const category = params.get("category"); // optional
       const listing_type = params.get("listing_type") || "sale";

      // Build the fetch URL dynamically
      let url = `${BASE_URL}/properties?property_type=${property_type}`;
      if (category) url += `&category=${category}`;
      if (listing_type) url += `&listing_type=${listing_type}`;

      const res = await fetch(url);
      const data = await res.json();
      console.log(data.data);

      if (data?.status && Array.isArray(data.data)) {
        setListings(data.data);
      } else {
        setListings([]);
      }
    } catch (err) {
      console.error(err);
      setListings([]);
    }
  };


  useEffect(() => {
    const updateHeight = () => {
      const headerH = headerRef.current?.offsetHeight || 0;
      const filterH = filterRef.current?.offsetHeight || 0;
      const h = Math.max(0, window.innerHeight - headerH - filterH);
      setResultHeight(`${h}px`);
    };
    updateHeight();
    getListings()
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const sortedListings = usePropertySort(listings, sort);

  const mapVisible = view === "both" || view === "map";
  const listVisible = view === "both" || view === "list";


  return (
    <>
      <div className="buy-main" >
        <div ref={headerRef}>
          <Header2 />
        </div>
        <div className="buy-filter" ref={filterRef}>
          <div className="view-box">
            <div className="filter-group">
              <Button
                className={`map-list d-none d-md-flex ${view === "both" ? "active" : ""}`}
                onClick={() => setView("both")}
                aria-pressed={view === "both"}
              >
                <img src={MapList} alt="" />
              </Button>
              <Button
                className={`map ${view === "map" ? "active" : ""}`}
                onClick={() => setView("map")}
                aria-pressed={view === "map"}>
                <img src={Map} alt="" />
              </Button>
              <Button className={`list ${view === "list" ? "active" : ""}`}
                onClick={() => setView("list")}
                aria-pressed={view === "list"}>
                <img src={List} alt="" />
              </Button>
            </div>
          </div>
          <FilterBar onSuburbChange={(suburb) => setCounty(suburb)} />
        </div>
        <div className="result-box" style={{ height: resultHeight, }}>
          <div className="result-map" style={{
            animation: mapVisible ? "slideInLeft 0.4s ease-in-out forwards" : "slideOutRight 0.4s ease-in-out forwards",
            flex: view === "both" ? "1" : view === "map" ? "1 1 100%" : "0 0 0",
            overflow: "hidden",
            minHeight: 0,
            display: mapVisible ? "flex" : "none",
          }}>
             <iframe
              title="Google Maps"
              style={{ width: "100%", height: "100%", border: 0 }}
              src={`https://maps.google.com/maps?q=${encodeURIComponent(county + ", Kenya")}&output=embed`}
              allowFullScreen
              loading="lazy"
            />
             </div>
          <div className={`result-list ${view === 'list' ? 'list-open' : ''}`} style={{
            animation: listVisible ? "slideInRight 0.4s ease-in-out forwards" : "slideOutLeft 0.4s ease-in-out forwards",
            flex: view === "both" ? "1" : view === "list" ? "1 1 100%" : "0 0 0",
            overflowY: "auto",
            minHeight: 0,
            display: listVisible ? "block" : "none",
          }}>
            <div className="result-list-header d-flex justify-content-between align-items-center">
              <CommercialHeader />
              <span>{sortedListings.length} result{sortedListings.length === 1 ? "" : "s"}</span>
              <Dropdown align="end" onSelect={(key) => key && setSort(key)}>
                <Dropdown.Toggle id="sort-dropdown" >
                  {sort === "Sort by" ? (
                    <>
                      Sort by
                    </>
                  ) : (
                    <>{sort}</>
                  )}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {[
                    "Homes for You",
                    "Price (High to Low)",
                    "Price (Low to High)",
                    "Newest",
                    "Bedrooms",
                    "Bathrooms",
                    "Square Feet",
                    "Lot Size",
                  ].map((opt) => (
                    <Dropdown.Item
                      key={opt}
                      eventKey={opt}
                      active={sort === opt}
                    >
                      {opt}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <ul>
              {sortedListings?.map((item) => (

                <li key={item.id}>
                  <Link to={`/commercial-details/${item.slug}`}>
                    <div className="result-item-img position-relative">
                      <Swiper
                        modules={[Autoplay, Pagination]}
                        spaceBetween={20}
                        centeredSlides={true}
                        slidesPerGroup={1}
                        // loop={true}
                        // autoplay={{ delay: 2500, disableOnInteraction: false }}
                        pagination={{ clickable: true }}
                      >
                        {item.images.length > 0 &&
                          item.images.slice(0, 3).map((url, idx) => (
                            <SwiperSlide key={idx}>
                              <Card className="border-0">
                                <Card.Img src={url.image} />
                              </Card>
                            </SwiperSlide>
                          ))
                        }


                      </Swiper>

                      {item.tag && <span className="recommended">{item.tag}</span>}
                      <span
                        key={item.id}
                        role="button"
                        tabIndex={0}
                        className={`wishlist ${isFavorite(item.id) ? "active" : ""}`}
                        onClick={(e) => {
                          e.preventDefault();
                          toggleFavorite(item.id);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") toggleFavorite(item.id);
                        }}
                      >

                        <img
                          src={Like}
                          alt="like"
                        />
                      </span>
                    </div>
                    <div className="result-item-info">
                      <h2>KES{item.price}</h2>
                      <p>{item.street_address}</p>
                      <div className="info-box">
                        <span>
                          <img src={storey} alt="" /> {item.details.floor_count}
                        </span>
                        <span>
                          <img src={power} alt="" /> {item.details.power_capacity_kva}
                        </span>
                        <span>
                          <img src={size} alt="" /> {item.size_sqft}
                        </span>
                      </div>
                      <h6>Listing by : <span>{item.listing_by?.name}</span></h6>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <Container>
        </Container>
      </div>
    </>
  );
}

export default Commercial;
